import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

const ReferralRedirectPage = () => {
  const { code } = useParams();

  useEffect(() => {
    /* =========================================
       VALIDATION
    ========================================= */

    if (!code || code.trim().length < 6) {
      window.location.replace("https://pitics.com");
      return;
    }

    const normalizedCode = code.trim().toUpperCase();

    /* =========================================
       OPTIONAL WEB STORAGE
    ========================================= */

    try {
      localStorage.setItem(
        "pitics_referral_code",
        normalizedCode
      );
    } catch (e) {
      console.warn(
        "Failed to store referral code",
        e
      );
    }

    /* =========================================
       REDIRECT TO PITICS PROXY
    ========================================= */

    window.location.replace(
      `https://api.pitics.com/ref/${encodeURIComponent(
        normalizedCode
      )}`
    );

  }, [code]);

  /* =========================================
     UI
  ========================================= */

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        textAlign: "center",
        padding: "20px",
        background: "#ffffff"
      }}
    >

      <img
        src="/logo.png"
        alt="Pitics"
        style={{
          width: "120px",
          marginBottom: "24px"
        }}
      />

      <h2
        style={{
          marginBottom: "12px"
        }}
      >
        Redirecting to Play Store...
      </h2>

      <p
        style={{
          fontSize: "16px",
          opacity: 0.8
        }}
      >
        Referral Code:{" "}
        <b>{code}</b>
      </p>

    </div>
  );
};

export default ReferralRedirectPage;